import { environment as defaultEnvironment } from '../../environments/environment';
import { isPrimitive } from 'util';

export const environmentLoader = new Promise<any>((resolve, reject) => {
  var getSubdomain = function() {
    let hostUrl = window.location.host;
    let parts = hostUrl.split(".");
    let subdomain = parts[0];

    let isLocalhost = subdomain.search('localhost') === 0 || 
                      hostUrl.search(/(\d*\.?){3}\d\:*\d*/) !== -1;

    let isProd = subdomain === 'www' || subdomain === 'rentascordoba';

    subdomain = isLocalhost ? '' :
                isProd ? '.PROD' : 
                '.'.concat(subdomain);
    
    subdomain = subdomain.toUpperCase();
    return subdomain;
  }

  var xmlhttp = new XMLHttpRequest(),
    method = 'GET',
    url = './assets/environments/environment'.concat(getSubdomain()).concat('.json');

  xmlhttp.open(method, url, true);

  xmlhttp.onload = function() {
    if (xmlhttp.status === 200) {
      resolve(JSON.parse(xmlhttp.responseText));
    } else {
      resolve(defaultEnvironment);
    }
  };

  xmlhttp.send();
});
